import { awsApiInstance } from '../api/aws-api';

import { IUpdateCustomer, IPostCustomerResponse } from '../models/customer.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Updates an existing user
 * 
 * @param {IUpdateCustomer} customer the form data
 * 
 * @returns {IPostCustomerResponse} the api response | error
 */
export const awsUpdateCustomer = async (customer: IUpdateCustomer): Promise<IPostCustomerResponse> => {
  try {
    const { data } = await awsApiInstance.put(`/customer/${customer.updateCustomerNum}`, customer );

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error updating user');
    throw(error);
  }
}